import { fetchGetBetsPosition, TGetBetsPositionResponse } from '../../../repositories/auction/v1/get-bets-position';
import { mapSuccessResponse } from './utils';
import { IGetBetPositionParams, TGetBetPositionResult } from './types';

export async function getBetPosition(params: IGetBetPositionParams): Promise<TGetBetPositionResult> {
  const { httpApi, logger, parameters } = params;

  const config = {
    requestConfig: {
      headers: [['Content-Type', 'application/json']] as [string, string][],
    },
  };

  try {
    const response: TGetBetsPositionResponse = await fetchGetBetsPosition({
      httpApi,
      parameters,
      config,
    });

    if (response.statusCode === 200) {
      return {
        success: true,
        payload: mapSuccessResponse(response.response),
      };
    }
  } catch (error) {
    logger.error(error, {
      description: 'Запрос get-bets-position на ФП',
      degradation: 'Пользователь не увидит позицию объявления на карточках ФВУ',
    });
  }

  return {
    success: false,
  };
}
